import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { PRINCIPAL_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const PrincipalService = ComposedComponent =>
  reduxFetch([
    {
      resource: PRINCIPAL_RESOURCE,
      method: 'get',
      request: (id, t) => ({
        url: apiRoutes.principals(id),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getPrincipalFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default PrincipalService;
